import { useEffect } from "react";

export const SideBar = (props) => {
    const { isOpen, onClose, title, content, isModal = true } = props;

    return (
        <>
            {isOpen && (
                <>
                    {" "}
                    {isModal ? (
                        <div className="flex justify-center items-center min-h-full">
                            <div x-data={{ open: isOpen }}>
                                <div
                                    x-show={isOpen && "open"}
                                    className="fixed inset-0 z-50 overflow-hidden"
                                >
                                    <div
                                        x-show={isOpen && "open"}
                                        x-transition:enter="transition-opacity ease-out duration-300"
                                        x-transition:enter-start="opacity-0"
                                        x-transition:enter-end="opacity-100"
                                        x-transition:leave="transition-opacity ease-in duration-300"
                                        x-transition:leave-start="opacity-100"
                                        x-transition:leave-end="opacity-0"
                                        className="absolute inset-0 bg-gray-500/75 transition-opacity"
                                        onClick={onClose}
                                    ></div>
                                    <section className="absolute inset-0 lg:inset-y-0 lg:inset-x-auto lg:right-0 lg:left-auto lg:pl-10 max-w-full flex">
                                        <div
                                            x-show={isOpen && "open"}
                                            x-transition:enter="transition-transform ease-out duration-300"
                                            x-transition:enter-start="transform translate-x-full"
                                            x-transition:enter-end="transform translate-x-0"
                                            x-transition:leave="transition-transform ease-in duration-300"
                                            x-transition:leave-start="transform translate-x-0"
                                            x-transition:leave-end="transform translate-x-full"
                                            className="w-full h-full lg:w-screen lg:h-auto lg:max-w-md"
                                        >
                                            <div className="h-full flex flex-col py-6 bg-white shadow-xl p-2">
                                                <div className="flex items-center justify-between px-4">
                                                    <h2 className="text-xl font-semibold text-black">
                                                        {title}
                                                    </h2>
                                                    <button
                                                        onClick={onClose}
                                                        className="text-gray-500 hover:text-gray-700 cursor-pointer"
                                                    >
                                                        <span className="sr-only">
                                                            Close
                                                        </span>
                                                        <svg
                                                            className="h-6 w-6"
                                                            x-description="Heroicon name: x"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            stroke="currentColor"
                                                            aria-hidden="true"
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeWidth="2"
                                                                d="M6 18L18 6M6 6l12 12"
                                                            ></path>
                                                        </svg>
                                                    </button>
                                                </div>
                                                <div className="mt-4 px-4 h-full overflow-auto">
                                                    <div>{content}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="h-full bg-white shadow-lg border-l border-gray-200">
                            <div className="flex justify-between items-center p-4 border-b">
                                <h2 className="text-lg font-semibold">
                                    {title}
                                </h2>
                                <button onClick={onClose} className="cursor-pointer">&times;</button>
                            </div>
                            <div className="p-4">{content}</div>
                        </div>
                    )}
                </>
            )}
        </>
    );
};
